import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';

import { useSettings, Utils } from 'app/main/components';

interface OrdersLinesTableFooterInfoProps {
	totTaxExcl?: number;
	totTaxExclPromosDiscount?: number;
	totMerchPoints?: number;
}

export default function OrdersLinesTableFooterInfo(props: OrdersLinesTableFooterInfoProps) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<div className="h-full p-6">
			{(props.totTaxExcl || props.totTaxExcl === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{ id: 'linesTable.totTaxExcluded', defaultMessage: t('TOT_VALUE_TAX_EXCLUDED') },
						{ value: Utils.formatCurrency(props.totTaxExcl) }
					)}
				</Typography>
			)}
			{(props.totTaxExclPromosDiscount || props.totTaxExclPromosDiscount === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{
							id: 'linesTable.totTaxExclPromosDiscount',
							defaultMessage: t('TOT_VALUE_TAX_EXCLUDED_PROMOS_DISCOUNT')
						},
						{ value: Utils.formatCurrency(props.totTaxExclPromosDiscount) }
					)}
				</Typography>
			)}
			{(props.totTaxExcl || props.totTaxExcl === 0) && (props.totMerchPoints || props.totMerchPoints === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{ id: 'linesTable.totMerchPoints', defaultMessage: t('TOT_MERCH_POINTS') },
						{ value: props.totMerchPoints }
					)}
				</Typography>
			)}
		</div>
	);
}
